import { render } from "./PostsPage.vue?vue&type=template&id=d36f7890"
import script from "./PostsPage.vue?vue&type=script&lang=js"
export * from "./PostsPage.vue?vue&type=script&lang=js"
script.render = render

export default script